// extracted by mini-css-extract-plugin
module.exports = {"transactionStepPage":"transactionStep_transactionStepPage__iJ929","step-item":"transactionStep_step-item__uhGRt","step-label":"transactionStep_step-label__MM3BP"};